import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import Ramrungroup from './ramrungroup/ramrungroup'
import { RootState } from '../../../../store/store'
import { useSelector } from 'react-redux'

const tutorTypes = ['aiTutor', 'teacher', 'parent']

const Studentramruns = () => {
	const navigate = useNavigate()
	const { pathname } = useLocation()

	// eslint-disable-next-line
	const [currentAssignedBy, setCurrentAssignedBy] = useState('aiTutor')

	const state = useSelector((state: RootState) => ({
		user: state.user.user,
	}))

	const { user } = state

	useEffect(() => {
		navigate(`${pathname}`, {
			state: {
				pageName: 'RamRuns'
			}
		})

		// eslint-disable-next-line
	}, [])

	return (
		<div className='pr-10 '>
			<div>
				<p className='font-semibold text-appcolorpurplefaintone text-[20px] leading-[24px] mb-[1.6rem]'>Assigned Runs</p>

				<div className='flex pb-4 border-b border-appcolorwhitefainttwo mb-9'>
					<div className={`flex items-center p-[1rem] cursor-pointer ${currentAssignedBy === tutorTypes[0] ? 'bg-appcolorpinktwo rounded-[16px] text-appcolorpurplefive font-semibold border border-appcolorprimaryblend' : ''}`}>
						{
							currentAssignedBy === tutorTypes[0]
								?
								<span className='bg-appcolorpurplefive h-[0.3rem] w-[0.3rem] rounded-full mr-[0.6rem]'></span>
								: null
						}
						<span className='text-base'>{user?.aiTutorDetails?.name}</span>
					</div>

					<div className={`flex items-center p-[1rem] cursor-pointer ${currentAssignedBy === tutorTypes[1] ? 'bg-appcolorpinktwo rounded-[16px]  border border-appcolorprimaryblend' : ''}`}>
						{
							currentAssignedBy === tutorTypes[1]
								?
								<span className='bg-appcolorpurplefive h-[0.3rem] w-[0.3rem] rounded-full mr-[0.6rem]'></span>
								: null
						}
						<span className='text-base'>Teacher</span>
					</div>

					<div className={`flex items-center p-[1rem] cursor-pointer ${currentAssignedBy === tutorTypes[2] ? 'bg-appcolorpinktwo rounded-[16px]  border border-appcolorprimaryblend' : ''}`}>
						{
							currentAssignedBy === tutorTypes[2]
								?
								<span className='bg-appcolorpurplefive h-[0.3rem] w-[0.3rem] rounded-full mr-[0.6rem]'></span>
								: null
						}
						<span className='text-base'>Parent</span>
					</div>
				</div>

				<div>
					<Ramrungroup />
				</div>
			</div>
		</div>
	)
}

export default Studentramruns